// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZOqo{align-items:center;display:flex;flex-direction:column;gap:8px;height:100%;justify-content:center;text-align:center;width:100%}.aZjy{--s:80px;height:80px;height:var(--s);width:80px;width:var(--s)}.Go15{display:grid}.JKOt{box-sizing:border-box!important;display:flex!important;height:100%!important;width:100%!important}.s\\+bP{border:1px solid var(--grey-200);display:grid;height:156px;overflow:hidden;width:100%}.s\\+bP+.s\\+bP{border-left-width:0}.s\\+bP:first-of-type{border-bottom-left-radius:4px;border-top-left-radius:4px}.s\\+bP:last-of-type{border-bottom-right-radius:4px;border-top-right-radius:4px}.kh5q{display:flex;flex-direction:column;gap:16px}.U3Mb{font-size:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionSidebarTypeTriggerButton": "ZOqo",
	"actionSidebarTypeTriggerButtonIcon": "aZjy",
	"actionSidebarTypeTriggerItem": "Go15",
	"actionSidebarTypeTriggerItemCtxButton": "JKOt",
	"actionSidebarTypeTriggerItemCtx": "s+bP",
	"actionSidebarTypeTriggerItemWrapper": "kh5q",
	"actionSidebarTypeTriggerButtonLabel": "U3Mb"
};
module.exports = ___CSS_LOADER_EXPORT___;
